// extracted by mini-css-extract-plugin
export default {"infoText":"UploadLogoModal_infoText__GYcXU"};